var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmailIntIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1169_138446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.12153 31.5037H8.84884V17.5947L5.09851 11.0459L0.666992 11.4583V29.0492C0.666992 30.4053 1.76541 31.5037 3.12153 31.5037Z",
    fill: "#0085F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4854 31.5037H34.2127C35.5688 31.5037 36.6672 30.4053 36.6672 29.0492V11.4583L32.2421 11.0459L28.4854 17.5947V31.5037H28.4854Z",
    fill: "#00A94B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4853 6.95821L25.1211 13.378L28.4853 17.5946L36.6672 11.4582V8.18551C36.6672 5.15209 33.2042 3.41959 30.7763 5.24005L28.4853 6.95821Z",
    fill: "#FFBC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.84882 17.5944L5.64307 10.8226L8.84882 6.95801L18.667 14.3216L28.4851 6.95801V17.5944L18.667 24.958L8.84882 17.5944Z",
    fill: "#FF4131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 8.18551V11.4582L8.84884 17.5946V6.95821L6.55791 5.24005C4.12995 3.41959 0.666992 5.15209 0.666992 8.18551Z",
    fill: "#E51C19"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1169_138446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.666992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailIntIcon);
export default __webpack_public_path__ + "static/media/gmail_int_icon.9dd78b310caad67a7d80e942d37e6bba.svg";
export { ForwardRef as ReactComponent };